var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 6L6 18","key":0}),React.createElement("path",{"d":"M6 6l12 12","key":1})]);
}

Close.defaultProps = {"viewBox":"0 0 24 24","width":"18","height":"18","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","fill":"none","shapeRendering":"geometricPrecision","style":{"color":"currentColor"}};

module.exports = Close;

Close.default = Close;
